import { Scaffold, type ScaffoldProps } from './scaffold.js';
import * as Dialog from '@studio/design-system/dialog';
import { forwardRef } from 'react';

interface Props extends ScaffoldProps {}

export const Panel = forwardRef<Dialog.Api, Props>((props, ref) => {
  return (
    <Dialog.Root ref={ref}>
      <Dialog.Overlay className='z-100'>
        <Dialog.Sheet>
          <Scaffold {...props} />
        </Dialog.Sheet>
      </Dialog.Overlay>
    </Dialog.Root>
  );
});
